export default __webpack_public_path__ + "static/media/searching.8e7a2d8d.svg";